<template lang="pug">
    cs-modal(
        :are-individual-settings="true",
        @close="$emit('close')",
    )
        .settings__title(slot="header")
            | {{ $i18n.t('trainer.trainer_multiplayerGame_individualSettingsForStudent', { playerName }) }}
        component(
            :is="currentGameIndividualSettingsComponent",
            :current-user-params="params",
            :slug="slug"
        )
        .settings__footer(slot="footer")
            cs-button(
                pattern="primary-outline",
                color="blue",
                @click.native.prevent="refreshParameters",
            )
                | {{ $i18n.t('trainer.trainer_gameFormSettings_resetSettings') }}
            cs-button(color="blue", @click.native.prevent="setNewParameters")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
</template>

<script>
    import { mapState } from 'vuex';
    import { cloneDeep, values } from 'lodash';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import MultiplicationAndDivisionMathMagic from "../multiplayer-individual-settings-forms/MultiplicationAndDivisionMathMagic";
    const AdditionAndSubtraction = () => import('../multiplayer-individual-settings-forms/AdditionAndSubtraction.vue');
    const InteractiveFlashCards = () => import('../multiplayer-individual-settings-forms/InteractiveFlashCards.vue');
    const Anzan = () => import('../multiplayer-individual-settings-forms/Anzan.vue');
    const MultiplicationAndDivision = () =>
        import('../multiplayer-individual-settings-forms/MultiplicationAndDivision.vue');
    const Equation = () => import('../multiplayer-individual-settings-forms/Equation.vue');
    const RootsAndDegrees = () => import('../multiplayer-individual-settings-forms/RootsAndDegrees.vue');

    const PARAMETERS_UPDATE_EVENT = 'parametersUpdate';

    export default {
        mounted() {
            this.parameters = this.paramsArray;
            this.params = cloneDeep(this.parameters[this.currentUserPosition]);
        },
        props: {
            playerName: {
                type: String,
                default: '',
            },
            currentUserPosition: {
                type: Number,
                default: 0,
            },
            slug: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                parameters: null,
                params: null,
            };
        },
        methods: {
            setNewParameters(withExit = true) {
                if (this.slug === 'InteractiveFlashCards') {
                    if (
                        this.params.difficult &&
                        typeof this.params.difficult === 'object' &&
                        (this.params.difficult.tens ||
                            this.params.difficult.hundreds ||
                            this.params.difficult.thousands)
                    ) {
                        if (this.params.difficult.digits) {
                            if (this.params.difficult.digits.length === 1) {
                                this.$toasted.error(this.$i18n.t('errors.incorrect_number_selected'));
                                return;
                            }
                        } else {
                            this.$toasted.error(this.$i18n.t('errors.select_number_between'));
                            return;
                        }
                    } else if (!values(this.params.difficult).filter(el => el).length) {
                        this.$toasted.error(this.$i18n.t('errors.select_at_least_one_option'));
                        return;
                    }
                }
                this.$set(this.parameters, this.currentUserPosition, this.params);
                this.$store.dispatch('setParamsArray', this.parameters);
                this.$emit(PARAMETERS_UPDATE_EVENT);
                if (withExit) {
                    this.$emit('close');
                }
            },
            refreshParameters() {
                let defaultParameters = cloneDeep(
                    getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: cloneDeep(this.params),
                        },
                    })
                );
                defaultParameters.playerName = this.params.playerName;
                this.params = defaultParameters;
                if (this.slug === 'InteractiveFlashCards') {
                    this.params.seriesAmount = 0;
                }
                this.setNewParameters(false);
            },
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
            }),
            currentGameIndividualSettingsComponent() {
                if (this.slug === 'AdditionAndSubtractionWithTime' || this.slug === 'AdditionAndSubtractionMathMagic') {
                    return 'AdditionAndSubtraction';
                }
                if (this.slug === 'AnzanWithTime') {
                    return 'Anzan';
                }
                if (this.slug === 'RootsAndSquares') {
                    return 'RootsAndDegrees';
                }
                return this.slug;
            },
        },
        components: {
            AdditionAndSubtraction,
            MultiplicationAndDivision,
            InteractiveFlashCards,
            Anzan,
            Equation,
            MultiplicationAndDivisionMathMagic,
            RootsAndDegrees,
        }
    };
</script>

<style lang="scss" scoped>
    .settings__title {
        text-align: center;
        font-size: 22px;
        font-weight: 500;
    }
    .settings__footer {
        display: flex;
        justify-content: center;
        @include media($xl) {
            padding-top: 10px;
        }
        :first-child {
            margin-right: 20px;
        }
    }
</style>
